var api = "https://api.qingcigame.com";

var index = '';
var _index = $('.index');

var initialSlide = 0; //设置默认索引为0
var change = true;
var num = 0; //当前播放歌曲的下标
var music = new Howl({
    src: ["//download4.qcplay.com/qcgame-admin/wNiFjUOf9mrfu6Tq2D9vjxbwLcGcPSTU80sZJa5w.mp3"],
    autoplay: true,
    loop: true,
    onplay: function() {
        $('.h-music-box').addClass('music-on'); //开始播放样式
    },
});
var musicCount = 0;

var obj = {
    index: function() {
        function getRequest() {
            var query = window.location.search;
            if (query.indexOf("?") != -1) {
                var str = query.substring(1);
                var strs = str.split("=");
                if (strs[1] == 1) {
                    initialSlide = 1;
                } else if (strs[1] == 2) {
                    initialSlide = 2;
                } else if (strs[1] == 3) {
                    initialSlide = 3;
                } else if (strs[1] == 4) {
                    initialSlide = 4;
                } else if (strs[1] == 5) {
                    initialSlide = 5;
                } else if (strs[1] == 6) {
                    initialSlide = 6;
                }
            }
        };
        getRequest(); //二级页面导航栏跳转
        this.preloading(); // 预加载
        this.onAdaptive();
        this.indexAjax(); // 首页数据
        this.jqslideTxtBox(); // 游戏咨询信息切换
        this.indexBind(); // 首页按钮
        this.hiddenNav();
        this.musicPlay(); //音乐播放
        // this.countNum(); //阿里云埋点
    },
    // 视听回廊
    galleryList: function() {
        this.pageShow();
        this.hiddenNav(); // 头部隐藏导航
        this.jqslideTxtBox(); // 游戏咨询信息切换
        setTimeout(() => {
            this.videoSwiper(); //视频轮播
        }, 500)
        this.wookmarkBind(); // 瀑布流图片
        this.galleryAjax(); //视听回廊接口
    },
    // 首页提示
    indexBind: function() {
        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            obj.countNum(mon_btn);
        })

        // 视频播放
        var Media = document.getElementById('media-play');
        $('.video-btn').click(function() {
            music.pause();
            musicCount = 1;
            $('.h-music-box').addClass('ani-pause');

            var _this = $(this);
            var data = _this.attr('data');
            $('.play-popup').fadeIn().find('video').attr('src', data);
            Media.play();
        });

        // 关闭视频
        $('.video-pop').click(function(event) {
            $('.popup').fadeOut().find('video').attr('src', '');
            Media.pause();

            music.play();
            $('.h-music-box').removeClass('ani-pause'); //去除暂时播放样式
            $('.h-music-box').addClass('music-on'); //开始播放样式
            musicCount = 0;
        });

        // 关闭弹窗
        $('.popup').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
        });

        // 关闭弹窗
        $('.popup').on('click', function(event) {
            $('.popup').fadeOut();
        });


        // 打开悬浮窗
        $('.float-nav .click-btn').click(function(event) {
            $('.float-nav').hasClass('nav-show') ? $('.float-nav').removeClass('nav-show') : $('.float-nav').addClass('nav-show');
            // $('.float-nav').addClass('nav-show');
        });

        // 关闭悬浮窗
        $('.nav-bg .back-btn').click(function(event) {
            $('.float-nav').removeClass('nav-show');
        });

        $('.swiper-container-video').on('click', '.swiper-slide', function(event) {
            var data = $(this).attr('data');
            $('.popup-wrap').fadeIn().find('iframe').attr('src', data);
        });

        $('.close-btn').click(function(event) {
            $('.popup').fadeOut().find('iframe').attr('src', '');
        });

        // 仙剑音画【壁纸】
        $(".wallpaper-box .item img").on('click', function() {
            var _this = $(this);
            var img_url = _this.attr('src');
            $('.wallpaper-wrap').fadeIn();
            $('.wallpaper-wrap img').attr("src", img_url);
        });

        $('.wallpaper-wrap').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
            setTimeout(() => {
                $('.wallpaper-wrap img').attr("src", '');
            }, 300)
        });

    },
    showSwiper: function() {
        var showSwiper = new Swiper('.swiper-container-show', {
            loop: true,
            paginationClickable: true,
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            // noSwiping: true,
            autoplay: 2000,
            spaceBetween: 100,
            autoplayDisableOnInteraction: false,
            navigation: {
                nextEl: '.swiper-button-next2',
                prevEl: '.swiper-button-prev2',
            },
            speed: 500,
            on: {
                init: function(swiper) {
                    swiperAnimate(this);
                },
                slideChangeTransitionStart: function(swiper) {
                    updateThumb(this.realIndex);
                },
            }
        });

        // 点击小按钮 => 切换大图 + 高亮 + 滚动
        $('#showBox .s-btn').each(function(idx) {
            $(this).on('click', function() {
                showSwiper.slideTo(idx);
                updateThumb(idx);
            });
        });

        function updateThumb(index) {
            var $ul = $('#showBox');
            var $lis = $ul.find('li');

            // 切换高亮
            $lis.removeClass('select');
            $lis.eq(index).addClass('select');

            // 滚动当前按钮到最左侧
            var container = document.querySelector('.show-click-box');
            var item = $lis.get(index);
            container.scrollTo({
                left: item.offsetLeft,
                behavior: 'smooth'
            });
        }
    },
    // 图片资源预加载
    preloading: function() {
        if (event.persisted || window.performance && window.performance.navigation.type == 2) {
            window.location.reload();
        }
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                // console.log(parseInt(e.progress * 100) + '%');
                $(".process-track .process-inner").width(parseInt(e.progress * 100) + '%');
                $(".process-percent #percent").html(parseInt(e.progress * 100));
            };
        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            var _this = this;
            $('.index').addClass('index-show');
            setTimeout(function() {
                _this.indexSwiper();
                $('#preloading').remove();
            }, 300)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的            
            '/official/images/mobile/index_content_bg_01-5fd9165a04.png',
            '/official/images/mobile/logo-6028255213.png',
            '/official/images/mobile/music_btn-6cf6ef8792.png',
            '/official/images/mobile/link_box-6d2e6593f8.png',
            '/official/images/mobile/video_btn1-5d223f9607.png',
            '/official/images/mobile/video_btn2-e7d1937172.png',
            '/official/images/mobile/video_play_btn-0c8dfd3ff8.png',
            '/official/images/mobile/header_bg-5bc68d2568.png',
            '/official/images/mobile/app_btn-753142c779.png',
            '/official/images/mobile/and_btn-61e6005d0f.png',
            '/official/images/mobile/index_code-ebf1f34a21.png',
            '/official/images/mobile/arrow_btn-8446befa51.png',
        ]);
    },
    onAdaptive: function() {
        const width = $(window).width();
        const height = $(window).height();
        const proportion = width / height;
        proportion < 0.568 ? _index.addClass('adaptive-0') : _index.removeClass('adaptive-0');
        proportion >= 0.568 && proportion < 0.606 ? _index.addClass('adaptive-1') : _index.removeClass('adaptive-1');
        proportion >= 0.606 && proportion < 0.650 ? _index.addClass('adaptive-2') : _index.removeClass('adaptive-2');
        proportion >= 0.650 ? _index.addClass('adaptive-3') : _index.removeClass('adaptive-3');
    },
    // 首页接口请求
    indexAjax: function() {
        var _this = this;

        // 下载地址
        var ios_url = 'https://apps.apple.com/us/app/id6742487527';
        var google_url = 'https://play.google.com/store/apps/details?id=com.qcplay.sakura.ggp.vn';
        // 关注我们地址
        var fb_url = 'https://www.facebook.com/profile.php?id=61569917674717';
        var tt_url = 'https://www.tiktok.com/@cardcaptorsakuravn?lang=zh-Hans';
        var fb_group_url = 'https://www.facebook.com/groups/1064322235747996';
        var ins_url = 'https://www.instagram.com/sakuramemorykey';
        // 充值平台地址
        var pay_url = 'https://pay.cardcaptor.vn/?gameId=121';

        // 下载按钮
        $('.app-btn').attr('href', ios_url);
        $('.google-btn').attr('href', google_url);
        // 关注我们按钮
        $('.facebook-btn , .fb-gz-btn').attr('href', fb_url);
        $('.tiktok-btn').attr('href', tt_url);
        $('.fb-group-gz-btn').attr('href', fb_group_url);
        $('.instagram-btn , .ins-gz-btn').attr('href', ins_url);
        // 充值平台按钮
        $('.pay-btn , .top-up-btn').attr('href', pay_url);

        _this.showSwiper(); //套装展示轮播
    },
    // 首页轮播
    indexSwiper: function() {
        function pageSwiper() {
            var mySwiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                direction: 'vertical',
                slidesPerView: 'auto',
                paginationClickable: true,
                spaceBetween: 0,
                mousewheel: true,
                resistanceRatio: 0,
                initialSlide: initialSlide,
                parallax: true,
                on: {
                    init: function() {
                        swiperAnimate(this);

                        function Ani(btn, page) {
                            $(btn).on('click', function() {
                                $('.float-nav').removeClass('nav-show');
                                $('.nav_more').removeClass('change');
                                change = true;
                                mySwiper.slideTo(page, 1000, true);
                            });
                        };

                        function navLink() {
                            for (var i = 6; i >= 0; i--) {
                                Ani('.nav-link-0' + i + ' .link-a', i);
                            };
                        }
                        navLink();

                        var aniLink01 = Ani('.arrow-btn', '1');
                        var aniLink02 = Ani('.arrow-b2', '2');
                        var aniLink03 = Ani('.arrow-b3', '3');
                        var aniLink04 = Ani('.arrow-b4', '4');
                    },
                    slideChangeTransitionEnd: function() {
                        swiperAnimate(this);
                        $('.nav-link').removeClass('on')
                        $('.nav-link-0' + this.activeIndex + '').addClass('on');
                    },
                },
            });
        }
        pageSwiper();

        function newsSwiper() {
            var swiperNews = new Swiper('.swiper-container-news', {
                loop: true,
                paginationClickable: true,
                pagination: {
                    el: '.swiper-pagination2',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 'auto',
                autoplay: true,
                autoplay: 2000,
            });
        }
        newsSwiper();

        function featureSwiper() {
            var charitySwiper = new Swiper('.swiper-container-feature', {
                loop: true,
                direction: 'horizontal',
                paginationClickable: true,
                pagination: {
                    el: '.swiper-pagination4',
                    clickable: true,
                },
                autoplayDisableOnInteraction: false,
                navigation: {
                    nextEl: '.swiper-button-next3',
                    prevEl: '.swiper-button-prev3',
                },
                initialSlide: 5,
                speed: 500,
                on: {
                    slideNextTransitionStart: function() {
                        $('.xk-wrap .hand').removeClass('h-next').addClass('h-prev')
                    },
                    slidePrevTransitionStart: function() {
                        $('.xk-wrap .hand').removeClass('h-prev').addClass('h-next')
                    }
                },
            });
            $('.xk-wrap .hand').on('animationend', function() {
                $(this).removeClass('h-next');
                $(this).removeClass('h-prev');
            })
        }
        featureSwiper();
    },
    // 视频轮播
    videoSwiper: function() {
        function videoSwiper() {
            var videoLoopSwiper = new Swiper('.swiper-container-video', {
                loop: false,
                loopedSlides: 'auto',
                slidesPerView: 'auto',
                observer: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
                speed: 300,
                onInit: function(swiper) {
                    swiper.slideTo(pageIndex === 1 ? imgIndex : videoIndex, 0, true);
                },
                onSlideChangeEnd: function(swiper) {
                    swiperAnimate(swiper);
                },
                onTouchEnd: function(swiper) {
                    swiperAnimate(swiper);
                },

            });
        };
        videoSwiper();
    },
    wookmarkBind: function() {
        var articleList = [
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/1.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/2.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/3.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/4.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/5.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/3.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/6.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/7.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/4.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/8.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/9.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/10.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/11.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/12.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/7.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/13.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/8.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/9.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/14.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/15.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/big/10.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/16.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/17.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/18.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/19.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/20.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/21.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/22.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/23.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/24.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/25.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/26.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/27.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/28.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/29.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/30.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/31.jpg' },
            { 'thumbnail': 'https://download4.qcplay.com/sakura/gallery/small/32.jpg' },
        ];
        $.each(articleList, function(index, values) {
            var dtHtml = '<li class="grid-item">' +
                '<img src=' + values.thumbnail + '>' +
                '</li>';
            $('#tiles').append(dtHtml);
        });

        $('#tiles').imagesLoaded(function() {
            var options = {
                itemWidth: 100,
                autoResize: true,
                container: $('#tiles'),
                offset: 15,
                outerOffset: 0,
                flexibleWidth: 120
            };
            var handler = $('#tiles li');
            handler.wookmark(options);
        });

        setTimeout(() => {
            $('.htmleaf-box').addClass('htmleaf-box-show');
        }, 1000);
    },
    // 游戏咨询&游戏攻略信息切换
    jqslideTxtBox: function() {
        jQuery(".slideTxtBox").slide({ effect: "left", trigger: "click", easing: "swing" });
        jQuery(".slideTxtBox-02").slide({ effect: "left", trigger: "click", easing: "swing" });
        jQuery(".gallery-box .main").slide({ effect: "left", trigger: "click", easing: "swing" });
    },
    // 视听回廊按钮事件
    galleryBind: function() {
        // 三个页面切换 初始化
        let page_id = this.getQueryVariable('page_id');
        $('.gallery-box .li-0' + page_id + '').addClass('on').siblings().removeClass('on');
        var btn = $('.gallery-box .li-0' + page_id + '');
        setTimeout(function() {
            btn.click();
        }, 300);

        // 视听回廊切换
        $('.gallery-box .hd li').click(function() {
            Media.pause();
            $('.record-player , .h-music-box').addClass('ani-pause'); //添加暂时播放样式
            $('.record-rocker').addClass('rocker-pause'); //添加暂时播放样式
            $('.music-box .play-box .play-btn').addClass('ani-pause'); //添加暂时播放样式
        });

        var Media = document.getElementById('media-play');
        // 媒体视频播放
        $('.video-btn').on('click', function(event) {
            var _this = $(this);
            $('.thumbnail-img').fadeOut(); //视频展示图
            $('.video-show-box video').fadeIn(); //视频
            $('.video-btn').fadeOut(); //视频按钮
            Media.play(); //播放
        });

        // 视频预览
        $('.swiper-container-video .videos-box').on('click', 'a', function() {
            var _this = $(this).find('img');
            var img_src = _this.attr('src');
            var video_src = _this.attr('data');
            var video_title = _this.attr('title');

            $(this).parent().addClass("on");
            $(this).parent().siblings().removeClass("on");
            $('.thumbnail-img').fadeIn();
            $('.video-show-box video').show();
            $('.video-btn').fadeIn();

            $('.thumbnail-img').find('img').attr('src', img_src); //图片填充
            $('.video-show-box').find('video').attr('src', video_src); //视频填充
            $('#videoName').html(video_title); //视频标题填充
            // Media.play(); //播放
        });

        // 歌曲选择按钮
        $('.select-btn').click(function(event) {
            $(".music-select-wrap").fadeIn();
        });

        // 点击背景关闭弹窗
        $('.music-select-wrap').click(function(event) {
            if ($(event.target)[0] == $(this)[0]) {
                $(this).fadeOut();
            }
        });

        // // 视听回廊【音乐】
        // //音乐播放按钮
        const myMusic = document.getElementById("myMusic");

        // 顶部music按钮点击时关闭视频
        $('.h-music-box').click(function(event) {
            Media.pause();
        });
    },
    // 视听回廊接口
    galleryAjax: function() {
        var _this = this;
        music.pause();
        $.ajax({
            url: api + "/web/article?cate_id=116&page=1&game_id=121",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var video = json.data.articleList.data; //视频

                    // 【游戏视频】
                    if (video.length !== 0) {
                        $(".video-show-box .thumbnail-img img").attr("src", video[0].thumbnail);
                        $(".video-show-box video").attr("src", video[0].video_link);
                        $(".content-box #videoName").html(video[0].article_title);
                        $(".content-box .content").html(video[0].article_excerpt);
                    }

                    $('.content-box #videoName').each(function() {
                        if ($(this).text().length > 11) {
                            var str = $(this).text();
                            $(this).text(str.substr(0, 11) + '...');
                        }
                    });

                    $('.content-box .content').each(function() {
                        if ($(this).text().length > 180) {
                            var str = $(this).text();
                            $(this).text(str.substr(0, 180) + '...');
                        }
                    });

                    $.each(video, function(index, values) {
                        var videoHtml = `<div class="swiper-slide videos-box">
                                <a href="javascript:;">
                                    <img src="${values.thumbnail}" data="${values.video_link}" title="${values.article_title}" alt="">
                                    <i></i>
                                    <b class="ani-btn"></b>
                                </a>
                            </div>`;
                        $('.swiper-container-video .slideVideoBox').append(videoHtml);
                    })
                    $('.swiper-container-video .slideVideoBox').children(':eq(0)').addClass('on');

                    _this.galleryBind();
                } else {
                    layer.msg("Lỗi yêu cầu máy chủ", { time: 2000 });
                }
            },
            error: function() {
                layer.msg("Lỗi yêu cầu máy chủ", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 隐藏导航
    hiddenNav: function() {
        // 隐藏导航
        $('.navBox').on('click', '.nav_more', function() {
            if (change == true) {
                $('.nav_more').addClass('change');
                $('.float-nav').addClass('nav-show');
                $('.nav-popup').addClass('nav-popup-show');
                change = false;
            } else {
                $('.nav_more').removeClass('change');
                $('.float-nav').removeClass('nav-show');
                $('.nav-popup').removeClass('nav-popup-show');
                change = true;
            }
            $('.screen-popup').fadeOut();
            $('.bottom-nav li').removeClass('on');
        });

        $('body').on('click', '.go-story', function(event) {
            $('.nav_more').removeClass('change');
            $('.nav-popup').removeClass('nav-popup-show');
            change = true;
        });
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    pageShow: function() {
        $('.page').addClass('pageShow');
    },
    musicPlay: function() {
        music.play();

        // 点击音乐
        $('.h-music-box').click(function(event) {
            if (musicCount == 1) {
                music.play();
                $(this).removeClass('ani-pause'); //去除暂时播放样式
                $(this).addClass('music-on'); //开始播放样式
                musicCount = 0;
            } else {
                $(this).addClass('ani-pause') //添加暂时播放样式
                music.pause();
                musicCount = 1;
            }
        });
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    }
}